import axios from '@/axios'
import helper from './helper'

export default {

  getAll() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/organisations`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  get(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/organisations/${id}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  create(item) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/organisations`, item)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  update(item) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/organisations`, item)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  remove(item) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/organisations/${item.id}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  }
}
